import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import PatrolList from './components/PatrolList';

const { Cell } = ResponsiveGrid;

const Patrol = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="巡邏列表"
        // description="巡邏列表"
        breadcrumbs={[
          {
            name: '巡邏管理',
          },
          {
            name: '巡邏列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <PatrolList />
    </Cell>
  </ResponsiveGrid>
);

export default Patrol;
